import { useTranslator } from '@bluebeam/react-i18n';
import DateDropdown from 'components/inputs/dropdowns/DateDropdown';
import Label from 'components/inputs/Label';
import React from 'react';

interface Props {
  value: number;
  onChange: (date: Date) => void;
  editable: boolean;
}

const DueDate = (props: Props): React.ReactElement => {
  const { translate } = useTranslator(['mapView']);
  const getDueDate = (): string => {
    const duedate = new Date(props.value * 1000);

    const localeOptions = { year: 'numeric', month: 'short', day: 'numeric' };

    return duedate.toLocaleDateString(
      'en-US',
      localeOptions as Intl.DateTimeFormatOptions
    );
  };

  const { editable, value, onChange } = props;

  return (
    <div>
      <Label label={translate('mapView:labels.dueDate')} />
      {editable ? (
        <DateDropdown
          id="update-punch-overlay-duedate"
          date={value}
          minDate={new Date()}
          onChange={onChange}
        />
      ) : (
        <div className="font-size-5 light">{getDueDate()}</div>
      )}
    </div>
  );
};

export default DueDate;
